module.exports = __webpack_public_path__ + "img/file-earmark-medical-fill.bacff188.svg";